import refs from '../helpers/refs'

class CBlockFeatures {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-block-features')
    .forEach(el => new CBlockFeatures(el))
})
